import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { useNavigate } from 'react-router-dom';
import { getAdminAccessState } from '../utils/adminAuth';

/**
 * Protects admin routes: Firestore admin role + MFA sign-in required.
 */
export function useAdminGuard() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [checking, setChecking] = useState(true);
  const [mfaEnrollmentRequired, setMfaEnrollmentRequired] = useState(false);
  const [needsMfaSignIn, setNeedsMfaSignIn] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (loading) return;

      if (!user) {
        setChecking(false);
        navigate('/admin/login', { replace: true });
        return;
      }

      try {
        let access = await getAdminAccessState(user);

        if (access.hasAdminRole && access.needsMfaSignIn) {
          await new Promise((resolve) => setTimeout(resolve, 750));
          access = await getAdminAccessState(user);
        }

        if (!access.hasAdminRole) {
          navigate('/admin/login', { replace: true });
          return;
        }

        setIsAdmin(access.isAdmin);
        setMfaEnrollmentRequired(access.mfaEnrollmentRequired);
        setNeedsMfaSignIn(access.needsMfaSignIn);
      } catch {
        navigate('/admin/login', { replace: true });
        return;
      } finally {
        setChecking(false);
      }
    };

    checkAdminStatus();
  }, [user, loading, navigate]);

  return {
    isAdmin,
    checking,
    mfaEnrollmentRequired,
    needsMfaSignIn,
    logout,
  };
}
